import { isLegalEnvironment } from '@frontend/AppSettings/environmentConfig';

/**
 * Projects and matters are the same `matters` row; the detail route tree is shared and the only
 * divergence is the environment's URL prefix. Legal serves `/matterDetails/*`; engineering serves
 * `/projectDetails/*` (where `ProjectDetailRouter` additionally branches converted bids to the
 * pipeline detail). Shared detail components (top bars, tables, create pages) use these helpers
 * so their in-page navigation resolves to a route that is actually registered for the running
 * environment — the legal routes are not mounted in engineering and vice versa.
 *
 * Functions, not module-scope consts: the environment is read at call time so tests that mock
 * `environmentConfig` per test case (the existing TopBar suites do) see the toggled value.
 */
export const detailRouteBase = (): string => (isLegalEnvironment ? '/matterDetails' : '/projectDetails');

/** Prefix for `pageContext.route` telemetry keys (`matters-files` vs `projects-files`, …). */
export const detailRoutePrefix = (): string => (isLegalEnvironment ? 'matters' : 'projects');
